const newsApi = process.env.NODE_ENV == 'production' ? "" : "/higgsNews"

export async function fetchData(postdata, url = '', method) {
  var params = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin':"*",
    },
    redirect: 'follow',
  }
  if ( method === 'POST' || !method) {
    params.body = postdata
  }
  if (method === 'GET' && postdata) {
    let queryArr = []
    // 过滤值为空字符串，null，undefined的参数
    Object.keys(postdata).filter(q => postdata[q] === 0 || postdata[q]).forEach(q => queryArr.push(`${q}=${postdata[q]}`))
    url = `${url}?${queryArr.join('&')}`
    postdata = false
  }

  return fetch(url, params).then((res) => {
    var response = res
    if (response.status >= 200 && response.status < 300) {
      return response.json()
    } else {
      var error = new Error(response.statusText)
      error.response = response
      throw error
    }
  }).catch((err) => {
    console.log(err)
  })
}

// 分类栏目
export function getArticleCategory(params) {
  const url = newsApi + '/api/categories'
  return fetchData(params, url,'GET')
}

// 图片轮播
export function getBanners(params) {
  const url = newsApi + '/api/banners'
  return fetchData(params, url,'GET')
}

// 推荐资讯
export function getRecommends(params) {
  const url = newsApi + '/api/recommends'
  return fetchData(params, url,'GET')
}

// 最新资讯
export function getLatests(params) {
  const url = newsApi + '/api/latests'
  return fetchData(params, url,'GET')
}

// 推荐资讯
export function getArticleRecommend(params) {
  const url = newsApi + '/api/recommends'
  return fetchData(params, url,'GET')
}

// 文章列表
export function getArticles(params) {
  const url = newsApi + '/api/articles'
  return fetchData(params, url, 'GET')
}

// 文章详情
export function getArticleDetail(params) {
  const url = newsApi + '/api/article/'+ params.id
  return fetchData(params, url,'GET')
}




